import { Box, Container, Typography } from "@mui/material";
import Hero from "../components/Hero";
import { useContent } from "../app/ContentContext";

function HomePage() {
  const { home } = useContent();
  return (
    <>
      <Hero />
      <Container maxWidth="md" sx={{ px: 2, py: { xs: 5, md: 7 } }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: "center",
            justifyContent: "center",
            gap: { xs: 3, sm: 5 },
          }}
        >
          <Typography
            variant="h6"
            color="text.secondary"
            sx={{ maxWidth: "500px", textAlign: { xs: "center", sm: "left" } }}
          >
            {home.intro}
          </Typography>
          <Box
            component="img"
            src="/helsevestlogo.webp"
            alt="Helse Vest Logo"
            sx={{
              width: { xs: "35%", sm: "18%" },
              maxWidth: "220px",
              height: "auto",
              flexShrink: 0,
            }}
          />
        </Box>
      </Container>
    </>
  );
}

export default HomePage;
